import * as THREE from "three";
import { Renderer } from "./Renderer";
import { Store } from "./Store";
import { Environment } from "./Enviroment";
import { InputSystem } from "./InputSystem";
import { Loading } from "../TOOLS/Loading";
import { Ui } from '../UI/Ui'
import { AssetManager } from "../TOOLS/AssetManager";
import { Datas } from "../DATABASE/Datas";
import { Toast } from "../TOOLS/Toast";
import { ModalController } from "../UI/2D/Modalcontroller";
import { LevelController } from "../UI/3D/LevelController";
import { Auth } from "../UI/Auth";




export class Main {
  constructor() {
    this.accumulator = 0;
    this.fixedTimeStep = 1 / 60;
    this.scene = new THREE.Scene();
    this.store = new Store();
      this.store.scene = this.scene;
      this.store.main = this;
    this.assetManager = new AssetManager(this.store);
      this.store.assetManager = this.assetManager
    this.renderer = new Renderer(this.store);
    this.environment = new Environment(this.store, this.scene, this.renderer.renderer);
    this.camera = this.environment.camera;
      this.store.enviroment = this.environment;
    this.renderer.handleResize(this.camera.camera);
    this.world = new THREE.Group();
      this.store.world = this.world;
    this.scene.add(this.world);
    this.loading = new Loading();
      this.store.loading = this.loading;
    this.inputSystem = new InputSystem(this.store);
      this.store.inputSystem = this.inputSystem;
    this.loop = this.loop.bind(this);
    this.lastTime = performance.now();
    this.datas = new Datas(this.store);
      this.store.datas = this.datas;
    this.toast = new Toast(this.store)
      this.store.toast = this.toast;
    this.levelController = new LevelController(this.store);
      this.store.levelController = this.levelController;
    this.modalController = new ModalController(this.store);
      this.store.modalController = this.modalController;
    this.authentication = new Auth(this.store);
      this.store.authentication = this.authentication;
    this.checkAuth();
  } 


  async checkAuth() {
    console.log('BUILD: ', '2026.11.01.10.28')

      this.store.level.userAnimation = 'ENTER';
      const loggedIn = await this.authentication.checkLoginExpiration();
      console.log('LOGGEDIN', loggedIn)
      if (loggedIn) {await this.init();
      } else {console.log('NOUSER');this.store.levelController.setLevel({name: "AUTH", hit: null, data: this.poolUser});}
  }

  async init() {
      await this.assetManager.preload();
      if (!this.ui) {
          this.ui = new Ui(this.store);
          this.store.ui = this.ui;
      }
      try {
        const headOffices = await this.store.datas.filter('CITIES', 'appearence', 'headoffice');
        await this.store.datas.load('USERS');
        this.store.database.districts = [...new Set(headOffices)];
        this.store.database.headoffices = headOffices;
        this.store.database.databaseLoaded = true;
      } catch (error) {
          console.error('FIRESTOREERROR', error);
      }
  }

  start() {requestAnimationFrame(this.loop);}

  loop(time) {
    const delta = (time - this.lastTime) / 1000;
    this.lastTime = time;
    this.accumulator += delta;
    // limit (spiral of death ellen)
    if (this.accumulator > 0.25) this.accumulator = 0.25;
    while (this.accumulator >= this.fixedTimeStep) {
      this.update(this.fixedTimeStep);
      this.accumulator -= this.fixedTimeStep;
    }
    this.render();
    requestAnimationFrame(this.loop);
  }

  update(delta) {
    this.inputSystem; 
    this.environment.update(delta);
    if (this.store.database.databaseLoaded) {this.ui.update(delta);}
    if (this.authentication) {this.authentication.update(delta);}
  }

  render() {this.renderer.render(this.scene, this.camera.camera);}
  
}
